export enum JournalEntryTypes {
  Unknown = 0,
  Pinned = 1,
  Unpinned = 2
}
